module.exports = __webpack_public_path__ + "assets/0f59a44473f269dd52d16cd186c00681.mp3";